module.exports = __webpack_public_path__ + "static/media/suncash.2c845ca9.svg";